__turbopack_context__.v({
  "CountDownTime": "page-module__uUHjBa__CountDownTime",
  "dfx_CheckCoinIcon": "page-module__uUHjBa__dfx_CheckCoinIcon",
  "dfx_CheckInBtn": "page-module__uUHjBa__dfx_CheckInBtn",
  "dfx_CheckInBtnCount": "page-module__uUHjBa__dfx_CheckInBtnCount",
  "dfx_CheckMyBalance": "page-module__uUHjBa__dfx_CheckMyBalance",
  "dfx_CheckMyBalanceIcon": "page-module__uUHjBa__dfx_CheckMyBalanceIcon",
  "dfx_CheckStreak": "page-module__uUHjBa__dfx_CheckStreak",
  "dfx_Check_Coins": "page-module__uUHjBa__dfx_Check_Coins",
  "dfx_Check_CoinsAndDays": "page-module__uUHjBa__dfx_Check_CoinsAndDays",
  "dfx_Check_CoinsContainer": "page-module__uUHjBa__dfx_Check_CoinsContainer",
  "dfx_Check_CoinsIcons": "page-module__uUHjBa__dfx_Check_CoinsIcons",
  "dfx_Check_CoinsIconsActive": "page-module__uUHjBa__dfx_Check_CoinsIconsActive",
  "dfx_Check_Day": "page-module__uUHjBa__dfx_Check_Day",
  "dfx_Check_In": "page-module__uUHjBa__dfx_Check_In",
  "dfx_Check_InBtn": "page-module__uUHjBa__dfx_Check_InBtn",
  "dfx_Check_RoundCoin": "page-module__uUHjBa__dfx_Check_RoundCoin",
  "dfx_Check_TooltipContainer": "page-module__uUHjBa__dfx_Check_TooltipContainer",
  "dfx_Claimed": "page-module__uUHjBa__dfx_Claimed",
  "dfx_CollectCoin": "page-module__uUHjBa__dfx_CollectCoin",
  "dfx_CollectCoinDays": "page-module__uUHjBa__dfx_CollectCoinDays",
  "dfx_Notification": "page-module__uUHjBa__dfx_Notification",
  "dfx_Share_popup": "page-module__uUHjBa__dfx_Share_popup",
  "dfx_Share_popupContent": "page-module__uUHjBa__dfx_Share_popupContent",
  "dfx_coinBonus": "page-module__uUHjBa__dfx_coinBonus",
  "dfx_coinBonusContent": "page-module__uUHjBa__dfx_coinBonusContent",
  "dfx_coinBonusInfo": "page-module__uUHjBa__dfx_coinBonusInfo",
  "dfx_coinBonusNumber": "page-module__uUHjBa__dfx_coinBonusNumber",
  "dfx_coinBonusdesc": "page-module__uUHjBa__dfx_coinBonusdesc",
  "dfx_coinContent": "page-module__uUHjBa__dfx_coinContent",
  "dfx_coinMainContainer": "page-module__uUHjBa__dfx_coinMainContainer",
  "dfx_coinSec": "page-module__uUHjBa__dfx_coinSec",
  "dfx_coinSecNew": "page-module__uUHjBa__dfx_coinSecNew",
  "dfx_coinTask": "page-module__uUHjBa__dfx_coinTask",
  "dfx_coinTaskContent": "page-module__uUHjBa__dfx_coinTaskContent",
  "dfx_coinTaskList": "page-module__uUHjBa__dfx_coinTaskList",
  "dfx_coinTaskTitle": "page-module__uUHjBa__dfx_coinTaskTitle",
  "dfx_coinTitle": "page-module__uUHjBa__dfx_coinTitle",
  "dfx_myBalance": "page-module__uUHjBa__dfx_myBalance",
  "dfx_shareWithfBtn": "page-module__uUHjBa__dfx_shareWithfBtn",
  "dfx_tooltip": "page-module__uUHjBa__dfx_tooltip",
  "dfx_tooltipDownArrow": "page-module__uUHjBa__dfx_tooltipDownArrow",
});
